import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ButtonBase, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface Props {
  stepCount: 1 | 2 | 3;
  stepName: string;
  variant?: 'small' | 'medium' | 'large' | 'full-width';
  highlight?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;

  collapse?(): void;
}

const PaiStepPanel: React.FC<Props> = ({ stepCount, stepName, variant = 'full-width', highlight, style, collapse, children }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  const getStepCountTitle = () => {
    switch (stepCount) {
      case 1:
        return t('firstStep');

      case 2:
        return t('secondStep');

      case 3:
        return t('thirdStep');

      default:
        return '';
    }
  };

  return (
    <div className={cx(classes.step, variant)} style={style}>
      {!_.isNil(collapse) ? (
        <ButtonBase className={classes.collapseButton} onClick={collapse}>
          <ArrowBackIcon className={classes.collapseIcon} />
        </ButtonBase>
      ) : null}
      <div className={classes.title}>
        <Typography className={cx(classes.titleText, highlight ? 'highlight' : undefined)}>{getStepCountTitle()}</Typography>
        <Typography className={cx(classes.titleText, highlight ? 'highlight' : undefined)}>{stepName}</Typography>
      </div>
      {children}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  step: {
    flexBasis: '100%',
    position: 'relative',
    '&.small': {
      flexBasis: '25%',
      [theme.breakpoints.down('lg')]: {
        flexBasis: '100%',
      },
    },
    '&.medium': {
      flexBasis: '50%',
      [theme.breakpoints.down('lg')]: {
        flexBasis: '100%',
      },
    },
    '&.large': {
      flexBasis: '75%',
      [theme.breakpoints.down('lg')]: {
        flexBasis: '100%',
      },
    },
    '&.full-width': {
      flexBasis: '100%',
    },
    background: '#FFF',
    boxShadow: Shadows.GREY_SHADOW_LIGHT,
    padding: '12px 16px',
    height: '100%',
  },
  collapseButton: {
    position: 'absolute',
    top: '12px',
    right: '16px',
    zIndex: 10,
  },
  collapseIcon: {
    fontSize: theme.typography.pxToRem(20),
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  title: {
    marginBottom: '32px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
    '&.highlight': {
      color: theme.palette.primary.main,
    },
  },
}));

export default PaiStepPanel;
